import React, { useEffect } from 'react';
import Product from '../../Product/Product';
import { useParams } from 'react-router-dom';
import { axiosInstance as axios } from '../../../axios/axios';
import Loader from '../../UI/Loader/Loader';
import { useDispatch } from 'react-redux';
import * as actionCreators from '../../../store/actionCreators';
import * as Action from '../../../store/actions';

const categories = [
  'Breads',
  'cookies',
  'donuts',
  'muffins',
  'tortillas',
  'chocolates',
];
function CategoryView() {
  const [products, setProducts] = React.useState(null);
  const params = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      try {
        setProducts(null);
        const res = await axios.get(`/api/home/categories/${params.id}`);
        console.log(res);
        setProducts(res.data.data.product);
      } catch (err) {
        console.log(err.message);
      }
    })();
  }, [params.id]);

  const addToCart = (data) => {
    dispatch(actionCreators.addToCart(data));
    dispatch({
      type: Action.CREATE_ERROR,
      payload: { msg: `${data.title} added to cart`, type: 'success' },
    });
  };
  return (
    <div>
      {!products && (
        <div className='h-[30rem] flex justify-center items-center'>
          <Loader />
        </div>
      )}

      {/* PRODUCTS */}
      <div className='grid grid-cols-12 gap-12 mt-8'>
        {products &&
          products.map((el, id) => {
            return (
              <div key={id} className='col-span-3'>
                <Product
                  productData={el}
                  addToCart={() =>
                    addToCart({
                      ...el,
                      noOfItems: 1,
                      total: parseInt(el.price),
                    })
                  }
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default CategoryView;
